export enum PathCardinalPointEnum {
  'N' = 'North',
  'NE' = 'North East',
  'E' = 'East',
  'SE' = 'South East',
  'S' = 'South',
  'SW' = 'South West',
  'W' = 'West',
  'NW' = 'North West',
}
